// extracted by mini-css-extract-plugin
export default {"offline":"CarCostOffline_offline__ykAST"};